import {FullDate as ApiFullDate} from 'gabi-api-ts/v2/common/date/date';
import {SignalType} from 'gabi-api-ts/v2/common/signals/signals';

import {SignalDefinitions, SignalDomainDefinition} from '@/model/signal-definitions/signal-definition';
import {defaultApiTime, getSecondsDifference, getSecondsFromMidnight} from '@/util/apidate-util';
import {floorMinute} from '@/util/date-utils';

function getDomainForEvents(maxEvents: number, dual: boolean): SignalDomainDefinition {
    maxEvents = Math.max(10, maxEvents);

    // Rounding maxEvents to a "round" number
    const tickStep = (
        maxEvents <= 20 ? 5 :
            maxEvents <= 40 ? 10 :
                maxEvents <= 100 ? 20 :
                    50
    );
    maxEvents = Math.ceil(maxEvents / tickStep) * tickStep;

    // Building ticks
    const ticks = [];
    for (let i= dual ? -maxEvents : 0; i <= maxEvents; i += tickStep) {
        ticks.push(i);
    }

    return {
        domain: [
            dual ? -maxEvents : 0,
            maxEvents
        ],
        ticks: ticks,
    };
}

function getDomainXForSignalSample(dateFrom: number, durationInSeconds: number): SignalDomainDefinition {
    const ticks = [];
    let currentTime = floorMinute(dateFrom).getTime() + 60000;
    while (currentTime <= dateFrom + durationInSeconds * 1000) {
        ticks.push(currentTime);
        currentTime += 60000;
    }
    return {
        domain: [dateFrom, dateFrom + durationInSeconds * 1000],
        ticks: ticks,
    };
}

function getXDomainFromTimeInterval(minTime: ApiFullDate, maxTime: ApiFullDate): SignalDomainDefinition {
    const durationInSeconds = getSecondsDifference(minTime, maxTime);
    const initialSeconds = getSecondsFromMidnight(minTime.time ?? defaultApiTime);
    const durationInHours = durationInSeconds / 3600;
    console.log('getXDomainFromSecondsInterval', durationInSeconds, durationInHours);
    const tickLength = (
        durationInHours < 2 ? 0.25 :
            durationInHours < 4 ? 0.5 :
                durationInHours < 16 ? 2 : 6
    );
    let duration = durationInHours;
    duration /= tickLength;
    duration = Math.ceil(duration);
    const out = [];
    for (let tick = 0; tick <= duration; ++tick) {
        out.push(initialSeconds + tick * tickLength * 3600);
    }
    return {
        domain: [0, duration * tickLength],
        ticks: out,
    };
}

function getDomainForDuration(durationInSeconds: number, returnSeconds?: boolean): SignalDomainDefinition {
    const durationInHours = durationInSeconds / 3600;
    console.log('getDomainForDuration', durationInSeconds, durationInHours);
    const tickLength = durationInHours < 16 ? 2 : 6;
    let duration = Math.max(10, durationInHours);
    duration /= tickLength;
    duration = Math.ceil(duration);
    const out = [];
    for (let tick = 0; tick <= duration; ++tick) {
        if (returnSeconds) {
            out.push(tick * tickLength * 3600);
        }
        else {
            out.push(tick * tickLength);
        }
    }
    return {
        domain: [0, duration * tickLength],
        ticks: out,
    };
}

function getDomainForSignalType(signalType: SignalType, min?: number, max?: number): SignalDomainDefinition {
    const domainDefinitions = (SignalDefinitions[signalType] ?? SignalDefinitions[-1]).chartDomain;

    if (!domainDefinitions.extended || typeof(min) === 'undefined' || typeof(max) === 'undefined') {
        return domainDefinitions.normal;
    }

    // Check for extended domain
    if (min < domainDefinitions.normal.domain[0] || max > domainDefinitions.normal.domain[1]) {
        return domainDefinitions.extended;
    }

    return domainDefinitions.normal;
}

export {
    getDomainForSignalType,
    getDomainXForSignalSample,
    getDomainForEvents,
    getDomainForDuration,
    getXDomainFromTimeInterval
};
